export default "__VITE_ASSET__DspWX_bp__"